import { createContext, useContext, type ReactNode } from 'react';
import { TherapyTimeInterval } from '@lmt/signal-viewer-ui';

export type DayNavigationValue = {
  selectedDayMs: number | null;
  onSelectedDayChange: (dayMs: number | null) => void;
  therapyTimeInterval: TherapyTimeInterval;
  onTimeIntervalToggle: () => void;
};

const DayNavigationContext = createContext<DayNavigationValue | null>(null);

export const DayNavigationProvider: React.FC<{
  value: DayNavigationValue;
  children: ReactNode;
}> = ({ value, children }) => (
  <DayNavigationContext.Provider value={value}>
    {children}
  </DayNavigationContext.Provider>
);

export const useDayNavigation = (): DayNavigationValue => {
  const value = useContext(DayNavigationContext);
  if (!value) {
    throw new Error(
      'useDayNavigation must be used inside a DayNavigationProvider',
    );
  }
  return value;
};
